import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import { LoginModel } from "../models/login.model";
import { WeGoConfig } from "../../shared/config";

@Component({
  selector: "wego-login",
  template: require('../views/login.component.html'),
})
export class LoginComponent implements OnInit {
  isLoading: boolean;
  isSSO: boolean;
  errorMessage: string;
  model: LoginModel;
  tenantid: string = "";
  subdomain:string = "";
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.translateService.setDefaultLang("en");
    this.translateService.setDetectedLang();
    this.model = new LoginModel("", "");

    this.subdomain = window.location.host.toLocaleLowerCase().split('.')[1] ? window.location.host.toLocaleLowerCase().split('.')[0] : "";
    if (this.subdomain.length > 0 && this.subdomain != 'bo') {
      this.SsoStep1();
      this.SsoStep2();
    }
  }

  OnSubmitSso() {
    this.isLoading = true;
    let tempVal = localStorage.getItem("computerId");
    localStorage.clear();
    localStorage.setItem("computerId", tempVal);

    var url = WeGoConfig.API_GET_INITIATE_SSO + this.tenantid + '?backoffice=true';
    window.location.href = url;
  }

  OnSubmit() {
    this.isLoading = true;
    let tempVal = localStorage.getItem("computerId");
    localStorage.clear();
    localStorage.setItem("computerId", tempVal);

    this.authService.Login(this.model.userName, this.model.password).subscribe(
      (res) => {
        this.isLoading = false;
      },
      (error) => {
        console.log(error);

        if (error.status == 401) {
          this.errorMessage = this.translateService.instant(
            "LblLoginCredentialsError"
          );
        } else {
          this.errorMessage = this.translateService.instant("LblLoginError");
        }
        this.isLoading = false;
      },
      () => {
        if (this.authService.isLoggedIn()) {
          this.router.navigate(["/backoffice"]);
        } else {
          console.log("Unauthorized");
        }
      }
    );
  }

  CheckIsAlreadyLoggedIn(): any {
    if (this.authService.isLoggedIn()) {
      if (this.authService.IsAdmin()) {
        this.router.navigate(["/admin"]);
      } else if (this.authService.IsDriver()) {
        this.router.navigate(["/driver"]);
      } else {
        this.router.navigate(["/underconstruction"]);
        this.authService.Logout();
        //localStorage.removeItem('current_role');
      }
    }
  }

  // Get tenantId by subdomain from ssoconfig settings
  public SsoStep1() {
    this.authService.GetSsoConfig(this.subdomain).subscribe(
      (res) => {
        if (res) {
          this.tenantid = res.data.tenantId;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        if (this.tenantid) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("current_role");
          localStorage.removeItem("user_setting");
          localStorage.removeItem("personMasterHashId");
          localStorage.removeItem("itemsPerPage");
          localStorage.removeItem("language");
          localStorage.removeItem("driverSelectedMenu");
          this.isSSO = true;
        } else {
          this.CheckIsAlreadyLoggedIn();
        }
      }
    );
  }

  public SsoStep2() {
    let saml = this.route.snapshot.queryParams["saml"];
    if (saml != null) {

      this.authService.GetSsoTokenAssertion(saml).subscribe(
        (res) => {
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
  
          if (error.status == 401) {
            this.errorMessage = this.translateService.instant(
              "LblLoginCredentialsError"
            );
          } else {
            this.errorMessage = this.translateService.instant("LblLoginError");
          }
          this.isLoading = false;
        },
        () => {
          if (this.authService.isLoggedIn()) {
            this.router.navigate(["/backoffice"]);
          } else {
            console.log("Unauthorized");
          }
        }
      );

    }
  }  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/login/components/login.component.ts